<template>
  <div class="water_box">
    <div
      class="pos_pointer"
      :style="`bottom:${
        ((waterPosition - 500) / 30) * 100 - 20 > 0 ? ((waterPosition - 500) / 30) * 100 - 20 : 0
      }%`"
    >
      {{ waterPosition }}m
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaterPostion',
  props: {
    position: { default: 10, required: true },
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    waterPosition() {
      const postion = this.position;
      console.log('((waterPosition - 500) / 30) * 100 :>> ', ((postion - 500) / 30) * 100);
      return postion;
    },
  },
};
</script>

<style lang="scss" scoped>
.water_box {
  width: 91px;
  height: 163px;
  background: url('../assets/hs/img_水位指标.png') no-repeat center;
  position: fixed;
  top: 710px;
  left: 540px;
  &::after {
    content: '库水位';
    position: absolute;
    right: -19px;
    bottom: -4px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
  }
  .pos_pointer {
    font-size: 20px;
    width: 68px;
    height: 20px;
    line-height: 20px;
    background: url('../assets/hs/img水位指标指针.png') no-repeat;
    padding-left: 23px;
    background-size: contain;
    position: absolute;
    left: 46px;
    bottom: 0%;
    color: rgba(190, 225, 249, 1);
    transition: all 3s;
  }
}
</style>
